import React, { Component } from "react"
import { DropzoneArea, DropzoneDialog } from "material-ui-dropzone"
import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import Chip from "@material-ui/core/Chip"
import Select from "@material-ui/core/Select"

import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import clsx from "clsx"
import IconButton from "@material-ui/core/IconButton"
import Input from "@material-ui/core/Input"
import CloseIcon from "@material-ui/icons/Close"
import FilledInput from "@material-ui/core/FilledInput"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import InputLabel from "@material-ui/core/InputLabel"
import InputAdornment from "@material-ui/core/InputAdornment"
import FormHelperText from "@material-ui/core/FormHelperText"
import FormControl from "@material-ui/core/FormControl"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"

import Card from "@material-ui/core/Card"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"

import { Row, Col } from "react-bootstrap"

import useMediaQuery from "@material-ui/core/useMediaQuery"

import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction"
import ListItemText from "@material-ui/core/ListItemText"
import Avatar from "@material-ui/core/Avatar"
import FormGroup from "@material-ui/core/FormGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import Grid from "@material-ui/core/Grid"
import FolderIcon from "@material-ui/icons/Folder"
import DeleteIcon from "@material-ui/icons/Delete"
import SettingsIcon from "@material-ui/icons/Settings"
import EditIcon from "@material-ui/icons/Edit"

import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import ExposurePlus1Icon from "@material-ui/icons/ExposurePlus1"
import AddIcon from "@material-ui/icons/Add"
import SaveIcon from "@material-ui/icons/Save"

import Megafone from "../../assets/megafone.svg"
import Comida from "../../assets/comida.svg"

import Switch from "@material-ui/core/Switch"

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        width: "100%",
    },
    rootcategoria: {
        // maxWidth: 345,
    },
    categoria: {
        margin: "0px!important",
        alignItems: "center",
    },
    ativo: {},
    inativo: {
        color: "#dc3545",
    },
    descricao: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        // width: "100%!important",
        display: "block",
        width: "95%",
    },
    margin: {
        // margin: theme.spacing(1),
        // padding: '10px',
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        background: "#f9f9f9",
        // width: '7em',
    },
    padding: {
        padding: "10px",
    },
    listItem: {
        display: "flex",
        alignItems: "center",
    },
    fullSize: {
        padding: "4px 200px 4px 16px",
    },
    smallSize: {
        padding: "4px 4px 4px 16px",
    },
    colOptions: {
        display: "flex",
        margin: "0.5em 0px",
        justifyContent: "center",
        alignItems: "center",
    },
    buttonAdicionarCategoria: {
        // margin: theme.spacing(1),
        // background: '#dc3545',
        // color: 'white',f
        // position: 'relative',
        // float: 'right',
    },
    buttonListAdicionarItem: {
        justifyContent: "center",
    },
    buttonAdicionarItem: {
        color: "#dc3545",
    },
}))

function getMoney(str) {
    console.log("str", str)
    var value = str.replace(/[\D]+/g, "")
    if (value == "") {
        return value
    }
    return parseInt(value)
}
function formatReal(int) {
    if (int == "") {
        return "0"
    }

    console.log("int", int)
    var tmp = int + ""
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1")
    if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2")

    return tmp
}

const changeValuePrice = e => {
    var value = formatReal(getMoney(e.target.value))
    e.target.value = value
}

export default function ConfiguracoesIniciais(props) {
    const classes = useStyles()
    const theme = useTheme()

    const { categoria } = props

    return (
        <Row
        // style={{marginTop: '2em'}}
        >
            <Col xs={3} md={3} lg={3} className={classes.colOptions}>
                <TextField
                    defaultValue={categoria.ordemExib}
                    label="Posição"
                    id="categoria_ordem_exibicao"
                    // size="small"
                    fullWidth
                    className={clsx(classes.margin, classes.textField)}
                    onChange={e => {
                        // changeValuePrice(e)
                    }}
                    variant="outlined"
                />
            </Col>
            <Col xs={9} md={9} lg={9} className={classes.colOptions}>
                <TextField
                    defaultValue={categoria.nome}
                    label="Nome"
                    // size="small"
                    id="categoria_nome"
                    fullWidth
                    className={clsx(classes.margin, classes.textField)}
                    onChange={e => {
                        // changeValuePrice(e)
                    }}
                    variant="outlined"
                />
            </Col>

            <Col xs={12} md={4} lg={4} className={classes.colOptions}>
                <FormControl fullWidth variant="outlined" className={classes.formControl}>
                    <InputLabel htmlFor="diaDisponivel">Dia Disponível</InputLabel>
                    <Select
                        native
                        fullWidth
                        defaultValue={categoria.diaSemana}
                        label="Dia Disponível"
                        className={clsx(classes.margin, classes.textField)}
                        inputProps={{
                            name: "Dia Disponível",
                            id: "categoria_dia_disponivel",
                        }}
                    >
                        <option value={null}>Todos os dias</option>
                        <option value={"DOMINGO"}>Domingo</option>
                        <option value={"SEGUNDA"}>Segunda</option>
                        <option value={"TERCA"}>Terça</option>
                        <option value={"QUARTA"}>Quarta</option>
                        <option value={"QUINTA"}>Quinta</option>
                        <option value={"SEXTA"}>Sexta</option>
                        <option value={"SABADO"}>Sabado</option>
                    </Select>
                </FormControl>
            </Col>
            <Col xs={12} md={4} lg={4} className={classes.colOptions}>
                <FormControl fullWidth variant="outlined" className={classes.formControl}>
                    <InputLabel htmlFor="turnoDisponivel">Turno Disponível</InputLabel>
                    <Select
                        native
                        fullWidth
                        defaultValue={categoria.turnoProduto}
                        label="Turno Disponível"
                        className={clsx(classes.margin, classes.textField)}
                        inputProps={{
                            name: "Turno Disponível",
                            id: "categoria_turno_disponivel",
                        }}
                    >
                        <option value={null}>Diurno e Noturno</option>
                        <option value={"APENAS_DIURNO"}>Apenas Diurno</option>
                        <option value={"APENAS_NOTURNO"}>Apenas Noturno</option>
                    </Select>
                </FormControl>
            </Col>
            <Col xs={12} md={4} lg={4} className={classes.colOptions}>
                <FormControl fullWidth variant="outlined" className={classes.formControl}>
                    <InputLabel htmlFor="exibicao">Exibição</InputLabel>
                    <Select
                        native
                        fullWidth
                        defaultValue={categoria.exibicaoCategoriaEnum}
                        label="Exibição"
                        className={clsx(classes.margin, classes.textField)}
                        inputProps={{
                            name: "Exibição",
                            id: "categoria_exibicao",
                        }}
                    >
                        <option value={null}>Total</option>
                        <option value={"DELIVERY"}>Apenas Delivery</option>
                        <option value={"PEDIDO_MESA"}>Apenas Pedido Mesa</option>
                    </Select>
                </FormControl>
            </Col>
        </Row>
    )
}
